import { BehaviorSubject } from 'rxjs';

const guestAddressSubject = new BehaviorSubject({
  submitAddress: () => {},
  isValid: false,
});

export const GuestAddressStore = {
  update: value => {
    guestAddressSubject.next(value);
  },
  subscribe: setState => guestAddressSubject.subscribe(setState),
  getValue: () => guestAddressSubject.value,
};
